import React, { useState, useCallback } from 'react';
import SendEffect from './SendEffect.js';
import { connect } from "react-redux";
import Dropdown from 'react-dropdown';
import {effectOptions, getEffectOption, initializeEffect} from 'components/effects/constants.js';
import '../../Sends.scss';

const SendComponent = (props) => {
    let [value, setValue] = useState(undefined);
    let channel = props.masterChannel || props.send;
    let effects = props.masterChannel ?
        props.masterChannel.effectsChain.effects : props.send.effects;

    const handleChooseEffect = useCallback((e) => {
        let effect = initializeEffect(e.value, props.sequencerEngine);
        effect.enable(true);
        if (effect.wetParameter) {
            effect.wetParameter.set(1);
        }
        channel.addEffect(effect);
        setValue(e.value);
        return false;
    }, [setValue, props.sequencerEngine, channel]);

    const moveEffectTo = useCallback((from, to) => {
        channel.moveEffectTo(from, to);
        setValue({from, to});
    }, [setValue, channel]);

    return (
        <div className="send">
          <div className="send-name">
            {props.name || props.send.name}
          </div>
          {effects.map(
              (effect, i) =>
                  <SendEffect key={effect.id} moveEffectTo={moveEffectTo} effectNumber={i} effect={effect}/>)}
          <Dropdown
            className='send-effects-dropdown'
            options={effectOptions}
            onChange={handleChooseEffect}
            placeholder="FX" />
        </div>
    );
}

const mapStateToProps = (state, props) => {
    if (props.masterChannel) {
        return {
            effects: props.masterChannel.effectsChain.effects
        };
    } else {
        return {
            effects: props.send.effects
        };
    }
};

export default connect(mapStateToProps, null)(SendComponent);

